import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from '../message.service';
import { RestApiService } from '../rest-api.service';
import { NotifierService } from 'angular-notifier';
import { Formatters } from 'angular-slickgrid';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CustomInputEditor } from '../custom-inputEditor';
import { FormControl } from '@angular/forms';


@Component({
    selector: 'app-ticket-menu-modified',
    templateUrl: './ticket-menu-modified.component.html',
    styleUrls: ['./ticket-menu-modified.component.css']
})
export class TicketMenumodifiedComponent implements OnInit, OnDestroy {


    groupSelected: number;
    show: boolean;
    dataset: any[];
    totalData: number;
    respObject: any;
    users = [];
    groups = [];
    fields = [];
    userName: string;
    groupName: string;

    slideChecked = true;
    displayData: any;

    add = false;
    del = false;
    edit = false;
    view = false;

    isError = false;
    errorMessage: string;
    actions = [];
    private notifier: NotifierService;
    private clientId: number;
    typeChecked: number;
    types: any;
    fieldSelected: any;
    private fieldName: any;
    fieldValues: any;
    fieldValueSelected: any;
    private fieldValueName: any;
    private seq: string;
    private type: any;
    private radioChecked: any;
    hideRadio = true;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private userAuth: Subscription;
    private baseFlag: any;
    dataLoaded: boolean;

    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    sgrpSelected: any;
    grps: any;
    field: string;
    showExportBtn = true;
    dataExcel = [];
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;

    groupSelectedArr = [];


    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
        private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            item.user_id = this.messageService.getUserId();
                            item.clientId = this.clientId;
                            this._rest.updateTicketMenu(item).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.notifier.notify('success', 'Updated successfully');
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            this._rest.deleteDynamicTabActionTicketTypeWise({
                                id: item.id,
                                user_id: this.messageService.getUserId()
                            }).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // this.totalData = this.totalData - 1;
                                    // this.messageService.setTotalData(this.totalData);
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        }
                    }
                    break;
            }
        });
        // this.messageService.getUserAuth().subscribe(details => {
        //   console.log(JSON.stringify(details));
        //   if (details.length > 0) {
        //     this.add = details[0].addFlag;
        //     this.del = details[0].deleteFlag;
        //     this.view = details[0].viewFlag;
        //     this.edit = details[0].editFlag;
        //   } else {
        //     this.add = true;
        //     this.del = true;
        //     this.view = true;
        //     this.edit = true;
        //   }
        // });
    }


    ngOnInit() {
        this.groupSelectedArr = [];
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain Ticket Menu Config',
            openModalButton: 'View Ticket Menu Config',
            searchModalButton: 'Search',
            breadcrumb: 'TicketMenuConfig',
            folderName: 'All Ticket Menu Config',
            tabName: 'Ticket Menu Config',
            exportBtn: 'Export to excel'

        };
        // this.messageService.setGridWidth(1000);
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'group', name: 'Group ', field: 'groupname', sortable: true, filterable: true
            },
            {
                id: 'user', name: 'User ', field: 'user', sortable: true, filterable: true
            },
            {
                id: 'type', name: 'Ticket Type ', field: 'type', sortable: true, filterable: true
            },
            {
                id: 'field', name: 'Action Type', field: 'actionType', sortable: true, filterable: true
            },
            {
                id: 'value', name: 'Action Value', field: 'value', sortable: true, filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    finalgroupsArr = [];
    onPageLoad() {
        this._rest.getSupportGroupByClientId(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;

                this.respObject.details.sort(function (a, b) {
                    return a.group_level - b.group_level;
                }
                );
                this.finalgroupsArr = this.respObject.details;
                this.groups = this.respObject.details;
                this.groups.unshift({ id: 0, name: 'Select Support Group' });
                this.groupSelected = 0;
                this.groupSelectedArr = [];
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            // console.log(JSON.stringify(this.respObject));
            if (this.respObject.success) {
                this.typeChecked = this.respObject.details[0].id;
                this.type = this.respObject.details[0].name;
                this.types = this.respObject.details;
                this.getAdditionalField();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    onUserChange(selectedIndex) {
        this.userName = this.users[selectedIndex].name;
    }



    exportToExcel() {
        // console.log("okkk" +this.clientId);
        this._rest.getAllViewTicketMenuConfiguration(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.dataExcel = this.respObject.details;
                console.log('true' + JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }
    groupFilter = [];
    selectedGroupFilter = [];
    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.users = [];
            this.groupSelected = 0;
            this.groupSelectedArr = [];
            this.fieldSelected = 0;
            this.fieldValues = [];
            this.groupFilter = [{ id: 0, name: 'All Group Levels' }, { id: 1, name: 'L0' }, { id: 2, name: 'L1' }, { id: 3, name: 'L2' },
            { id: 4, name: 'L3' }, { id: 5, name: 'L4' }, { id: 6, name: 'L5' }]
            this.selectedGroupFilter = this.groupFilter[0];
            this.modalService.open(content, { size: 'lg' }).result.then((result) => {
            }, (reason) => {
            });
        }
    }

    onGroupFilterChange(Value) {
        this.groups = [{ id: -1, name: 'Select All' }];
        this.dataLoaded = false;
        for (let i = 0; i < Value.length; i++) {
            console.log('Value ==> ' + Value[i]);
            let a = Value[i] - 1;
            console.log('to Search Value ==> ' + a);

            if (Value[i] === 0) {
                this.groups = this.finalgroupsArr;
                this.groups.unshift({ id: 0, name: 'Support Group' }, { id: -1, name: 'Select All' });
                break;
            } else {
                for (let i = 0; i < this.finalgroupsArr.length; i++) {
                    if (this.finalgroupsArr[i].group_level === a) {
                        this.groups.push(this.finalgroupsArr[i]);
                    }
                }
            }
        }
        this.dataLoaded = true;
    }

    searchModal() {

        this.sgrpSelected = '';
        this.searchModalReference = this.modalService.open(this.scarch_content);
        this.searchModalReference.result.then((result) => {
        }, (reason) => {

        });

    }
    search() {
        this._rest.searchAllViewTicketMenuConfiguration(this.sgrpSelected, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.grps = this.respObject.details;
                this.messageService.setTotalData(this.grps.length);
                this.messageService.setGridData(this.grps);
                this.searchModalReference.close();

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }
    save() {
        const activity = [];
        for (let i = 0; i < this.selectedFieldValue.length; i++) {
            activity.push(this.selectedFieldValue[i].id);

        }
        const data = {
            clientId: this.clientId,
            functionalityId: this.fieldSelected,
            ticketTypeId: this.typeChecked,
            addActivityLt: activity,
            createdBy: this.messageService.getUserId(),
            allUser: false,
            radioChecked: this.radioChecked
        };

        if (this.radioChecked === 2) {
            data['supportGroupLevelId'] = this.groupSelected;
        } else {
            data['supportGroupLevelId1'] = this.groupSelectedArr;
        }

        // console.log(activity);
        // console.log(JSON.stringify(this.selectedFieldValue));
        // console.log(JSON.stringify(data));
        if (!this.messageService.isBlankField(data) && this.selectedFieldValue.length > 0) {
            if (this.radioChecked === 2) {
                data['userLt'] = this.userSelected;
                console.log(JSON.stringify(data));
                this.dataLoaded = false;
                this._rest.insertAdditionalFuncTicketTypeUserWise(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.dataLoaded = true;
                        this.isError = false;
                        const id = this.respObject.id;
                        this.nextOffset = 0;
                        this.page_no = 0;
                        this.getTableData();
                        this.users = [];
                        this.groupSelected = 0;
                        this.groupSelectedArr = [];
                        this.fieldSelected = 0;
                        this.fieldValues = [];
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });

            } else {
                data['allUser'] = true;
                this.dataLoaded = false;
                for (let i = 0; i < this.groupSelectedArr.length; i++) {

                    data['supportGroupLevelId'] = this.groupSelectedArr[i];
                    console.log(JSON.stringify(data));
                    this._rest.insertAdditionalFuncTicketTypeUserWise(data).subscribe((res) => {
                        this.respObject = res;
                        if (this.respObject.success) {

                            if (i === this.groupSelectedArr.length - 1) {
                                this.isError = false;
                                const id = this.respObject.id;
                                this.nextOffset = 0;
                                this.page_no = 0;
                                this.getTableData();
                                this.users = [];
                                this.groupSelected = 0;
                                this.groupSelectedArr = [];
                                this.fieldSelected = 0;
                                this.fieldValues = [];
                                this.dataLoaded = false;
                            }
                        } else {
                            this.isError = true;
                            this.errorMessage = this.respObject.errorMessage;
                        }
                    }, (err) => {
                        this.isError = true;
                        this.errorMessage = this.messageService.SERVER_ERROR;

                    });
                }



            }

        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getAdditionalFuncTicketTypeUserWise(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                let data = respObject.details.dataObj;                
                this.nextOffset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }


    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
    }

    onRadioButtonChange(selectedValue) {
        this.radioChecked = selectedValue.value;
        if (this.radioChecked === 2) {
            this._rest.getUserByGroup(this.clientId, this.groupSelected).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    this.isError = false;
                    this.users = this.respObject.details;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.users = [];
        }
        console.log(typeof this.radioChecked);
    }
    userSelected :any;
    onGroupChange(selectedIndex: any) {
        this.groupName = this.groups[selectedIndex].name;
        this.hideRadio = false;
        this._rest.getUserByGroup(this.clientId, this.groupSelected).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.isError = false;
            this.respObject.details.unshift({id: 0, name: 'Select User'});
            this.users = this.respObject.details;
            //this.userSelected = 0;
          } else {
            this.isError = true;
            this.errorMessage = this.respObject.errorMessage;
          }
        }, (err) => {
          this.isError = true;
          this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    onGroupChange1(val) {
        console.log('selectedIndex1 ==> ' + JSON.stringify(val));
        // for (let i = 0; i < val.length; i++) {
        //     if (val[i] === -1 || val[i] === 0) {
        //         for (let i1 = 0; i1 < this.finalgroupsArr.length; i1++) {
        //             if (this.finalgroupsArr[i1].id === 0 || this.finalgroupsArr[i1].id === -1) {

        //             } else {
        //                 this.groupSelectedArr.push(this.finalgroupsArr[i1].id);
        //             }

        //         }
        //         console.log('groupSelectedArr ==> ' + JSON.stringify(this.groupSelectedArr));
        //         break;
        //     }
        // }
        for (let i = 0; i < val.length; i++) {
            if (val[i] === -1 || val[i] === 0) {
                this.groupSelectedArr.splice(val[i], 1);
            }
        }
        console.log('groupSelectedArr ==> ' + JSON.stringify(this.groupSelectedArr));
    }

    slideChange() {
        this.slideChecked = !this.slideChecked;
    }

    get selectedOptions() {
        return this.users
            .filter(opt => opt.checked)
            .map(opt => opt.id);

    }

    get selectedFieldValue() {
        return this.fieldValues
            .filter(opt => opt.checked)
            .map(opt => opt);

    }

    getAdditionalField() {
        this._rest.getAdditionalFunc().subscribe((res1) => {
            this.respObject = res1;
            // console.log(JSON.stringify(res1));
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select Additional Field' });
                this.fields = this.respObject.details;
                this.fieldSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    onButtonChange(value) {
        this.typeChecked = value.value;
        this.getAdditionalField();
    }

    onFieldChange(selectedIndex: any) {
        this.fieldName = this.fields[selectedIndex].name;
        this._rest.getAdditionalFuncTicketTypeWise(this.clientId, this.fieldSelected).subscribe((res1) => {
            this.respObject = res1;
            // console.log(JSON.stringify(res1));
            if (this.respObject.success) {
                this.isError = false;
                // this.respObject.details.unshift({id: 0, name: 'Select Field Value'});
                this.fieldValues = this.respObject.details;
                this.fieldValueSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    // onFieldValueChange(selectedIndex: any) {
    //   this.fieldValueName = this.fieldValues[selectedIndex].name;
    //   this.seq = this.fieldValues[selectedIndex].seq;
    //   console.log(this.seq);
    // }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }
}
